import { useState } from 'react';
import { Plus, Trash2, Clock } from 'lucide-react';
import './ShiftTemplates.css';

function calcNetHours(start, end) {
  if (!start || !end) return null;
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  let raw = (eh + em / 60) - (sh + sm / 60);
  if (raw <= 0) raw += 24; // overnight shift
  return raw > 0 ? raw - 0.5 : null;
}

function fmtHours(h) {
  if (h === null) return '—';
  const hrs = Math.floor(h);
  const mins = Math.round((h - hrs) * 60);
  return mins === 0 ? `${hrs}u` : `${hrs}u ${mins}m`;
}

export default function ShiftTemplates({ shifts = [], onAddShift, onDeleteShift }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [name, setName] = useState('');
  const [startTime, setStartTime] = useState('08:00');
  const [endTime, setEndTime] = useState('16:00');
  const [error, setError] = useState('');

  const netHours = calcNetHours(startTime, endTime);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) { setError('Vul een naam in'); return; }
    if (netHours === null || netHours <= 0) { setError('Ongeldige tijden'); return; }
    try {
      await onAddShift({ name: name.trim(), startTime, endTime });
      setName(''); setStartTime('08:00'); setEndTime('16:00'); setError('');
      setIsModalOpen(false);
    } catch (err) {
      setError(err.message || 'Fout bij opslaan');
    }
  };

  return (
    <div className="shifts-page">
      <div className="shifts-header">
        <div>
          <h2>Dienstroosters</h2>
          <p>Beheer diensten met vaste tijden</p>
        </div>
        <button className="add-template-btn" onClick={() => setIsModalOpen(true)}>
          <Plus size={16} /> Nieuwe dienst
        </button>
      </div>

      <div className="shifts-grid">
        {shifts.length === 0 ? (
          <div className="no-templates"><p>Nog geen diensten aangemaakt.</p></div>
        ) : (
          shifts.map((s) => {
            const net = calcNetHours(s.startTime, s.endTime);
            return (
              <div key={s.id} className="shift-card">
                <div className="shift-card-top">
                  <span className="shift-card-name">{s.name}</span>
                  <button className="delete-template-btn" onClick={() => onDeleteShift(s.id)} title="Verwijderen">
                    <Trash2 size={14} />
                  </button>
                </div>
                <div className="shift-card-times">
                  <Clock size={13} />
                  <span>{s.startTime} – {s.endTime}</span>
                </div>
                <div className="shift-card-hours">
                  <div className="shift-hours-row">
                    <span className="shift-hours-label">Bruto</span>
                    <span className="shift-hours-val">{fmtHours(net !== null ? net + 0.5 : null)}</span>
                  </div>
                  <div className="shift-hours-row">
                    <span className="shift-hours-label">Pauze</span>
                    <span className="shift-hours-val shift-break">− 30 min</span>
                  </div>
                  <div className="shift-hours-row net">
                    <span className="shift-hours-label">Netto</span>
                    <span className="shift-hours-val shift-net">{fmtHours(net)}</span>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h4>Nieuwe dienst</h4>
              <button className="modal-close" onClick={() => setIsModalOpen(false)}>✕</button>
            </div>
            <form onSubmit={handleSubmit} className="template-form">
              <div className="form-group">
                <label>Naam</label>
                <input
                  type="text"
                  placeholder="bijv. Dagdienst"
                  value={name}
                  onChange={(e) => { setName(e.target.value); setError(''); }}
                  autoFocus
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Begintijd</label>
                  <input type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
                </div>
                <div className="form-group">
                  <label>Eindtijd</label>
                  <input type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
                </div>
              </div>
              {netHours !== null && netHours > 0 && (
                <div className="hours-preview">
                  {startTime} – {endTime} &nbsp;•&nbsp; {fmtHours(netHours + 0.5)} bruto &nbsp;−&nbsp; 30 min pauze &nbsp;= &nbsp;<strong>{fmtHours(netHours)} netto</strong>
                </div>
              )}
              {error && <div className="form-error">{error}</div>}
              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={() => setIsModalOpen(false)}>Annuleren</button>
                <button type="submit" className="btn-submit"><Plus size={14} /> Opslaan</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
